import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  XMarkIcon,
  TicketIcon as TicketIconOutline,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import { confirmAlert } from "react-confirm-alert";
import _ from "lodash";
import moment from "moment";
import {
  fetchSingleOrder,
  palceTicketOrder,
  fetchEventUserCategories,
  openUserEditModal,
} from "@ticketsaction";
import { fetchStripeConnection, fetchEventInterests } from "@mainaction";
import { classNames, priceDisplayLocally } from "@utilscommon";
import { CDN_BASE_IMAGES_URL } from "@constant";
import Stripe from "@stripepay";
import Paypal from "@paypalpay";
import Razorpay from "@razorpaypay";
import Loader from "@loader";
import LocaleStrings from "@language";
import TicketAssign from "./ticket-assign-item";
import UserDeatilsEdit from "./userinfo-edit";
import brokenCircle from "../../../../assets/image/check-circle-broken.svg";
import SocialShare from "../../../social-promotion/components/social-share";

const OrderAssign = (props) => {
  const { ordernumber } = useParams();
  const location = useLocation();
  const {
    session,
    eventData,
    eventSettingsData,
    orderData,
    stripeConnection,
    isUserEditopen,
  } = props;
  const [loading, setLoading] = useState(false);
  const [invalidOrder, setInvalidOrder] = useState({ status: false, code: "" });
  const [orderErrorMessage, setOrderErrorMessage] = useState("");
  const [onlinePaymentKeys, setOnlinePaymentKeys] = useState({});
  const [callfromAdmin, setCallfromAdmin] = useState(false);
  const thankyoualertRef = useRef(null);
  const alertRef = useRef(null);
  let eventdate = "-";
  if (eventData?.eventstartdate && eventData?.eventenddate) {
    let startDate = eventData?.eventstartdate.split("-");
    let endDate = eventData?.eventenddate.split("-");
    let y1 = startDate[0],
      m1 = startDate[1],
      d1 = startDate[2],
      y2 = endDate[0],
      m2 = endDate[1],
      d2 = endDate[2];

    if (m1 === m2 && y1 === y2 && d1 === d2) {
      let month = moment(eventData?.eventstartdate).format("MMM");
      let date = moment(eventData?.eventstartdate).format("DD");
      let day = moment(eventData?.eventstartdate).format("ddd");
      eventdate = `${day}, ${month} ${date}, ${y1}`;
    } else if (m1 === m2 && y1 === y2 && d1 !== d2) {
      let month = moment(eventData?.eventstartdate).format("MMM");
      let date1 = moment(eventData?.eventstartdate).format("DD");
      let date2 = moment(eventData?.eventenddate).format("DD");
      let day1 = moment(eventData?.eventstartdate).format("ddd");
      let day2 = moment(eventData?.eventenddate).format("ddd");
      eventdate = `${day1}, ${month} ${date1} - ${day2}, ${date2}, ${y1}`;
    } else {
      let month1 = moment(eventData?.eventstartdate).format("MMM");
      let month2 = moment(eventData?.eventenddate).format("MMM");
      let date1 = moment(eventData?.eventstartdate).format("DD");
      let date2 = moment(eventData?.eventenddate).format("DD");
      let day1 = moment(eventData?.eventstartdate).format("ddd");
      let day2 = moment(eventData?.eventenddate).format("ddd");
      if (y1 === y2) {
        eventdate = `${day1}, ${month1} ${date1} - ${day2}, ${month2} ${date2}, ${y1}`;
      } else {
        eventdate = `${day1}, ${month1} ${date1}, ${y1} - ${day2}, ${month2} ${date2}, ${y2}`;
      }
    }
  }
  let paymantType = "";
  let email = "";
  let username = "";
  let vat = "";
  let company_name = "";
  let street = "";
  let city = "";
  let postal = "";
  let country = "";
  if (orderData?.data) {
    email = orderData?.data?.email;
    username = orderData?.data?.username;
    vat = orderData?.data?.vat;
    company_name = orderData?.data?.company_name;
    street = orderData?.data?.street;
    city = orderData?.data?.city;
    postal = orderData?.data?.postal;
    country = orderData?.data?.country;
  }
  let buyerInfo = { email: email, name: username };
  let billingAccountInfo = eventData?.platform_billing_account
    ? JSON.parse(eventData.platform_billing_account)
    : { stripe: "AU" };
  let otherprops = { billingaccount: billingAccountInfo };

  if (
    orderData?.data?.status === "cancel" ||
    orderData?.data?.status === "refund"
  ) {
    paymantType = "cancel";
  } else if (
    orderData?.data?.paymentstatus === "paid" &&
    orderData?.data?.status === "approve"
  ) {
    paymantType = "completed";
  } else if (
    orderData?.data?.paymentmethod === "paylater" &&
    orderData?.data?.paymentstatus === "pending" &&
    orderData?.data?.status === "pending"
  ) {
    paymantType = "offline";
  }
  let pdfname = `order-${orderData?.data?.orderid}.pdf`;
  if (paymantType === "offline") {
    pdfname = `order-off-${orderData?.data?.orderid}.pdf`;
  }
  let invoiceUrl = `${CDN_BASE_IMAGES_URL}/eventify/${orderData?.data?.eventid}/invoice/${pdfname}?download=true`;
  let totalAmount = orderData?.data?.customeramount;
  let currency = orderData?.data?.currency;
  let showPaymentGateway = orderData?.data?.allowonlinepayment ?? false;
  let onlineFee = orderData?.data?.onlinefee ?? 0;
  let orderUserAssign = orderData?.data?.orderdetails ?? [];
  let totalAmountWithFee = totalAmount + onlineFee; // Add fee amount if any and send it to payment gateways component

  // console.log("paymantType :- ", paymantType);
  // console.log("orderData :- ", orderData);
  // console.log("orderUserAssign :- ", orderUserAssign);

  useEffect(() => {
    // console.log("ordernumber :- ", ordernumber);
    if (!ordernumber) {
      return;
    }

    props.fetchEventInterests(session, (response) => {});
    props.fetchEventUserCategories(session, (res) => {});

    let data = { ordernumber: ordernumber, eventid: eventData?.eventid };
    props.fetchSingleOrder(session, data, (response) => {
      if (response?.success === 1) {
        if (
          response?.data?.paymentmethod === "paylater" &&
          response?.data?.paymentstatus === "pending" &&
          response?.data?.status === "pending"
        ) {
          props.fetchStripeConnection(session, () => {});
        }
      } else {
        setInvalidOrder({ status: true, code: response.data.code });
      }
    });
    const searchParams = new URLSearchParams(location.search);
    const isEdit = searchParams.get("edit") === "true";
    if (isEdit) {
      setCallfromAdmin(true);
    }
  }, [ordernumber]);

  const handleTicketOrder = (action) => {
    let value = { orderid: orderData?.data?.id, type: action };

    setLoading(true);
    props.palceTicketOrder(session, value, (response) => {
      // console.log("response paylater intent :- ", response);

      setLoading(false);
      if (response.success === 1) {
        setOnlinePaymentKeys({
          ...(response?.data ?? {}),
          gateway: response?.data?.gateway,
          id: response?.data?.transactionId,
          secret: response?.data?.clientSecret,
        });
      } else if (response.success === 2) {
        if (response?.data?.code === "orderid_required") {
          setOrderErrorMessage(LocaleStrings.kOrderidRequiredText);
        } else if (response?.data?.code === "invalid_orderid") {
          setOrderErrorMessage(LocaleStrings.kInvalidOrderidText);
        } else if (response?.data?.code === "order_cancelled") {
          setOrderErrorMessage(LocaleStrings.kOrderAlreadyCancelledText);
        } else if (response?.data?.code === "order_already_confirmed") {
          setOrderErrorMessage(LocaleStrings.kOrderAlreadyConfirmedText);
        } else if (response?.data?.code === "invalid_eventid") {
          setOrderErrorMessage(LocaleStrings.kInvalidEventText);
        } else if (response?.data?.code === "email_domain_not_allowed") {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kInvalidEmailDomainText,
              "###DOMAIN###",
              response?.data?.resource?.domain
            )
          );
        } else if (response?.data?.code === "organizer_credit_limit_used") {
          let hostCredit = response?.data?.resource?.total_userlimit_credits;
          let usedCredit =
            response?.data?.resource?.total_userlimit_credits_used;
          let availableCredit =
            hostCredit > usedCredit ? hostCredit - usedCredit : 0;

          setOrderErrorMessage(
            availableCredit > 0
              ? _.replace(
                  LocaleStrings.kHostCreditLimitLeftText,
                  /###LEFTQUANTITY###/g,
                  availableCredit
                )
              : LocaleStrings.kHostCreditLimitUsedText
          );
        } else if (response?.data?.code === "event_capacity_full") {
          setOrderErrorMessage(
            response?.data?.resource?.leftseat > 0
              ? _.replace(
                  LocaleStrings.kEventCapacityLeftText,
                  /#leftquantity/g,
                  response?.data?.resource?.leftseat
                )
              : LocaleStrings.kEventCapacityFullTicketText
          );
        } else if (response?.data?.code === "stripe_account_not_connected") {
          setOrderErrorMessage(LocaleStrings.kStripeNotConnectedText);
        } else if (response?.data?.code === "stripe_payment_intent_error") {
          setOrderErrorMessage(LocaleStrings.kStripePaymentNotInitiatedText);
        } else if (
          response?.data?.code === "assigned_attendee_email_domain_not_allowed"
        ) {
          setOrderErrorMessage(
            _.replace(
              LocaleStrings.kAssignedEmailInvalidDomainText,
              "###DOMAIN###",
              response?.data?.resource?.domains
            )
          );
        } else if (
          response?.data?.code === "invalid_eventify_payment_gateway_accountid"
        ) {
          setOrderErrorMessage(
            LocaleStrings.kInvalidEventifyPaymentGatewayAccountText
          );
        } else if (
          response?.data?.code === "currency_not_supportable_razorpay"
        ) {
          setOrderErrorMessage(LocaleStrings.kCurrencyNotSupportableText);
        } else {
          setOrderErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
        }
      } else {
        setOrderErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
      }
    });
  };

  const closeThankYouAlert = () => {
    thankyoualertRef.current.className = "hidden";
  };

  const closeAlert = () => {
    alertRef.current.className = "hidden";
    setOrderErrorMessage("");
  };

  const renderOrdertickets = () => {
    const grouped = _.uniqBy(orderUserAssign, "id");

    return _.map(grouped, (item, index) => {
      return (
        <li
          key={`tickets_key_${index}`}
          className={`custom-text-primary-md-normal ORDER_SUMMARY_TICKET ORDER_SUMMARY_TICKET_${item?.tickecode} ORDER_SUMMARY_TICKET_POSITION_${item?.position}`}
        >
          {item?.quantity} x {item?.ticketname}
        </li>
      );
    });
  };

  const renderTicketAssign = () => {
    return _.map(orderUserAssign, (item, index) => {
      return (
        <TicketAssign
          key={`tickets_key_${index}`}
          form={`TicketAssignForm_${item?.id}${item?.position}`}
          assign={item}
        />
      );
    });
  };

  const openUseredit = () => {
    props.openUserEditModal(true);
  };

  let attachInvoice = true; // Check if free order invoice attachment enabled or not
  if (
    (!eventSettingsData?.data?.freeinvoiceattach &&
      orderData?.data?.invoicetype === "free") ||
    (!eventSettingsData?.data?.paidinvoiceattach &&
      orderData?.data?.invoicetype === "paid")
  ) {
    attachInvoice = false;
  }
  // Get external offline thankyou message
  let offlineThankYouMessage = "";
  if (
    eventSettingsData?.data?.offlinecongratulations &&
    eventSettingsData?.data?.offlinecongratulations !== ""
  ) {
    offlineThankYouMessage = eventSettingsData?.data?.offlinecongratulations;
  }

  let isSocialEnabled = false;
  if (eventSettingsData?.data) {
    const custom_settings = JSON.parse(eventSettingsData.data.custom_settings);
    isSocialEnabled =
      custom_settings?.socialboost_setting?.boostenabled ?? false;
  }

  return (
    <>
      {orderData?.data ? (
        <>
          {invalidOrder.status ? (
            <div className="content-body flex items-center justify-center flex-col space-y-2">
              <TicketIconOutline className="text-secondary w-20 h-20 rotate-135" />

              <div className="no-content-text">
                {invalidOrder.code === "order_refunded"
                  ? LocaleStrings.kRefundedOrderText
                  : invalidOrder.code === "order_cancelled"
                  ? LocaleStrings.kCancelledOrderText
                  : invalidOrder.code === "admin_order_pending"
                  ? LocaleStrings.kAdminOrderPendingText
                  : LocaleStrings.kInvalidOrderText}
              </div>
            </div>
          ) : (
            <div
              className="content-body rounded-xl bg-[#F9FAFB]"
              // style={{ padding: "4rem" }}
            >
              {/* Thank You message */}
              {paymantType === "completed" ? (
                <>
                  <div className="flex flex-col justify-center items-center space-y-3 mb-12 THANK_YOU_SECTION">
                    <img
                      src={brokenCircle}
                      alt="Tick icon"
                      className="BROKEN_CIRCLE"
                    />
                    <div className="text-2xl font-semibold THANK_YOU_TEXT">
                      {LocaleStrings.kThankYouPurchaseText}
                    </div>
                    <div className="text-base font-normal break-words text-center THANK_YOU_DESCRIPTION">
                      {LocaleStrings.kTicketPurchaseText.replace(
                        "###EMAIL###",
                        email
                      )}
                    </div>
                  </div>
                  {isSocialEnabled ? <SocialShare /> : ""}
                </>
              ) : (
                ""
              )}

              {/* Order details */}
              <div className="sm:grid sm:grid-cols-5 overflow-hidden space-y-3 sm:space-y-0 ORDER_DETAILS_SECTION">
                <div className="sm:col-span-3 ORDER_SUMMARY_SECTION">
                  <div className="section-title mb-2 ORDER_SUMMARY_TEXT">
                    {LocaleStrings.kOrderSummaryText}
                  </div>

                  {/* render order ticket details */}
                  <ul
                    className="mb-1 ORDER_SUMMARY_LIST"
                    style={{ width: "70%" }}
                  >
                    {renderOrdertickets()}
                  </ul>

                  {/* Invoice download */}
                  {(paymantType === "completed" || paymantType === "offline") &&
                  attachInvoice ? (
                    <>
                      {eventData?.eventid === 1798901876269958 ||
                      eventData?.eventid === 1803874955878530 ? (
                        ""
                      ) : (
                        <a
                          className="custom-text-theme-md-medium hover:underline DOWNLOAD_INVOICE_BUTTON"
                          href={invoiceUrl}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          {LocaleStrings.kDownloadInvoice}
                        </a>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="sm:col-span-2 BUYER_DETAILS_SECTION">
                  <div className="flex items-center space-x-3 mb-2 w-1/2 ">
                    <div className="section-title BUYER_DETAILS_TEXT">
                      {LocaleStrings.kBuyerDetailsText}
                    </div>
                    {callfromAdmin ? (
                      <div
                        className="text-sm font-semibold uppercase cursor-pointer text-primary BUYER_DETAILS_EDIT"
                        onClick={openUseredit}
                      >
                        <PencilSquareIcon className="text-theme w-5 h-5 BUYER_DETAILS_EDIT_ICON" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {username ? (
                    <div className="custom-text-primary-md-normal BUYER_DETAILS_NAME">
                      <span className="font-medium">
                        {LocaleStrings.kLabelFullName}:
                      </span>{" "}
                      {username}
                    </div>
                  ) : (
                    ""
                  )}
                  {email ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_EMAIL">
                      <span className="font-medium">
                        {LocaleStrings.kEmail}:
                      </span>{" "}
                      {email}
                    </div>
                  ) : (
                    ""
                  )}
                  {vat ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_VAT">
                      <span className="font-medium">
                        {LocaleStrings.kLabelVatNo}:
                      </span>{" "}
                      {vat}
                    </div>
                  ) : (
                    ""
                  )}
                  {company_name ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_COMPANY">
                      <span className="font-medium">
                        {LocaleStrings.kLabelBilledTo}:
                      </span>{" "}
                      {company_name}
                    </div>
                  ) : (
                    ""
                  )}
                  {street ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_STREET">
                      <span className="font-medium">
                        {LocaleStrings.kLabelStreet}:
                      </span>{" "}
                      {street}
                    </div>
                  ) : (
                    ""
                  )}
                  {city ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_CITY">
                      <span className="font-medium">
                        {LocaleStrings.kLabelCity}:
                      </span>{" "}
                      {city}
                    </div>
                  ) : (
                    ""
                  )}
                  {postal ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_POSTAL">
                      <span className="font-medium">
                        {LocaleStrings.kLabelPostal}:
                      </span>{" "}
                      {postal}
                    </div>
                  ) : (
                    ""
                  )}
                  {country ? (
                    <div className="custom-text-primary-md-normal mt-1 BUYER_DETAILS_COUNTRY">
                      <span className="font-medium">
                        {LocaleStrings.kCountryText}:
                      </span>{" "}
                      {country}
                    </div>
                  ) : (
                    ""
                  )}

                  <a
                    className="cursor-pointer custom-text-theme-md-medium hover:underline ADD_TO_CALENDAR_BUTTON"
                    onClick={() =>
                      confirmAlert({
                        customUI: () => {
                          return (
                            <div>
                              <AddToCalendarButton
                                name={eventData.eventname}
                                options={[
                                  "Apple",
                                  "Google",
                                  "Outlook.com",
                                  "Yahoo",
                                  "iCal",
                                ]}
                                location={eventData.country}
                                startDate={eventData.eventstartdate}
                                timeZone={eventData.eventtimezone}
                                endDate={eventData.eventenddate}
                                startTime="00:00"
                                endTime="23:59"
                                label={LocaleStrings.kSaveToCalendar}
                                buttonsList
                                buttonStyle="round"
                                lightMode="bodyScheme"
                              />
                            </div>
                          );
                        },
                      })
                    }
                  >
                    {LocaleStrings.kSaveToCalendar}
                  </a>
                </div>
              </div>

              {/* divider */}
              <div className="relative py-4 THANK_YOU_PAGE_DIVIDER">
                <div
                  className="absolute inset-0 flex items-center"
                  aria-hidden="true"
                >
                  <div className="w-full border-t border-gray-300" />
                </div>
              </div>
              {/* divider */}

              {paymantType === "offline" ? (
                <>
                  {onlinePaymentKeys?.gateway &&
                  stripeConnection?.data?.stripeaccountid ? (
                    <>
                      {onlinePaymentKeys?.gateway === "paypal" ? (
                        <Paypal
                          onlinePaymentKeys={onlinePaymentKeys}
                          paypalAccountId={
                            stripeConnection?.data?.stripeaccountid
                          }
                          amount={totalAmountWithFee}
                          currency={currency}
                          otherprops={otherprops}
                        />
                      ) : onlinePaymentKeys?.gateway === "razorpay" ? (
                        <Razorpay
                          onlinePaymentKeys={onlinePaymentKeys}
                          paypalAccountId={
                            stripeConnection?.data?.stripeaccountid
                          }
                          amount={totalAmountWithFee}
                          currency={currency}
                          otherprops={otherprops}
                          buyerinfo={buyerInfo}
                        />
                      ) : (
                        <Stripe
                          onlinePaymentKeys={onlinePaymentKeys}
                          stripeAccountId={
                            stripeConnection?.data?.stripeaccountid
                          }
                          amount={totalAmountWithFee}
                          currency={currency}
                          otherprops={otherprops}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {orderErrorMessage !== "" ? (
                        <div ref={alertRef}>
                          <div className="rounded-md bg-red-50 border border-red-200 p-4 mb-4">
                            <div className="flex">
                              <p className="text-base font-normal text-customred">
                                {orderErrorMessage}
                              </p>

                              <div className="ml-auto pl-3">
                                <div className="-mx-1.5 -my-1.5">
                                  <button
                                    type="button"
                                    className="inline-flex rounded-md bg-red-50 p-1.5 text-red-600 hover:bg-red-100 focus:outline-none"
                                    onClick={closeAlert}
                                  >
                                    <span className="sr-only">Dismiss</span>
                                    <XMarkIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        className="custom-text-primary-md-normal mb-5"
                        dangerouslySetInnerHTML={{
                          __html:
                            offlineThankYouMessage !== ""
                              ? offlineThankYouMessage
                              : LocaleStrings.kOrderPaylaterPaymentText,
                        }}
                      ></div>

                      {showPaymentGateway && (
                        <button
                          type="button"
                          className="theme-button-md"
                          onClick={() =>
                            handleTicketOrder("paylater_payment_intent")
                          }
                          disabled={loading}
                        >
                          <svg
                            className={classNames(
                              loading ? "" : "hidden",
                              "cust-btn-spinner"
                            )}
                            viewBox="0 0 1024 1024"
                            focusable="false"
                            data-icon="btnloading"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                          </svg>{" "}
                          {_.replace(
                            LocaleStrings.kPayAmountText,
                            "#amount",
                            onlineFee > 0
                              ? `${currency} ${priceDisplayLocally(
                                  totalAmount
                                )} + ${priceDisplayLocally(onlineFee)}`
                              : `${currency} ${priceDisplayLocally(
                                  totalAmount
                                )}`
                          )}
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : paymantType === "completed" ? (
                <>
                  {/* Ticket assigne section */}
                  <div className="ASSIGN_TICKETS_SECTION">
                    <div className="section-title mb-2 ASSIGN_TICKETS_TEXT">
                      {orderData?.data?.isselfassign
                        ? LocaleStrings.kMyTicketsText
                        : LocaleStrings.kAssignedTicketsText}
                    </div>

                    <div className="overflow-hidden rounded-md border border-default bg-white ASSIGN_TICKETS_LISTS">
                      <ul className="divide-y divide-gray-300">
                        {renderTicketAssign()}
                      </ul>
                    </div>
                  </div>
                </>
              ) : paymantType === "cancel" ? (
                <div className="custom-item-center h-40 custom-text-secondary-2xl-bold">
                  {LocaleStrings.kOrderCancelledText}
                </div>
              ) : (
                ""
              )}

              <div className="text-[#667085] mt-8 text-base SUPPORT_EMAIL">
                {" "}
                {LocaleStrings.ksupportText.replace(
                  "###SUPPORTMAIL###",
                  eventSettingsData?.data?.supportemail ?? ""
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="content-body">
          <Loader />
        </div>
      )}
      {isUserEditopen ? <UserDeatilsEdit /> : ""}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
    orderData: state.orderData,
    stripeConnection: state.stripeConnection,
    isUserEditopen: state.isUserEditopen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchSingleOrder,
      palceTicketOrder,
      fetchStripeConnection,
      fetchEventUserCategories,
      fetchEventInterests,
      openUserEditModal,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderAssign);
